import { useEffect } from "react";
import {
  makeAjax,
  url,
  respStatus,
  showMessage,
} from "../../helpers/global_helper";

const SeoDymanicContent = ({ payload, setPageContent }) => {
  useEffect(() => {
    const fetchInformation = async () => {
      const payloadData = { code: payload };
      console.log("Fetching information with payload:", payload);

      try {
        const response = await makeAjax(
          url.USER_API.getTextInfo,
          payloadData,
          url.USER_MS_EXT
        );
        if (response.status !== respStatus["SUCCESS"]) {
          showMessage(response);
          return null;
        }
        return response.data?.value || null;
      } catch (error) {
        console.error("Error fetching information:", error);
        return null;
      }
    };

    //loadInformation 
    const loadInformation = async () => {
      const data = await fetchInformation();
      if (data) {
        // Extract <style> and body content
        const styleMatches = data.match(/<style>(.*?)<\/style>/s);
        const bodyContent = data.replace(/<style>(.*?)<\/style>/s, "");
          
        if (payload === "about_us") {
          setPageContent(data);
        } else {
          // Insert styles into <head>
          if (styleMatches && styleMatches[1]) {
            const styleTag = document.createElement("style");
            styleTag.innerHTML = styleMatches[1];
            document.head.appendChild(styleTag);
          }

          // Insert body content into <body>
          const titleElement = document.head.querySelector("title");
          const bodyElement = document.body;
          if (bodyElement) {
              if (titleElement) {
                titleElement.insertAdjacentHTML("afterend", bodyContent);
              }
            // Add event listeners for newly added elements
            const buttons = document.querySelectorAll(".c-circle-menu__link");
            buttons.forEach((button) => {
              button.addEventListener("click", () => {
                // Add custom click logic here
              });
            });

            // Event delegation for dynamic content
            document.body.addEventListener("click", handleDynamicClick);
          }
        }
      }
    };

    loadInformation();

    return () => {
      document.body.removeEventListener("click", handleDynamicClick);
      // Optional: Remove dynamically added styles if needed
      const addedStyles = document.querySelectorAll("style");
      addedStyles.forEach((style) => {
        if (style.innerHTML.includes("<style>")) {
          style.remove();
        }
      });
    };
  }, [payload, setPageContent]);

  // Event delegation handler
  const handleDynamicClick = (event) => {
    const closeButton = document.getElementById("CloseButton");
    if (closeButton && closeButton.contains(event.target)) {
      const menu = closeButton.querySelector(".c-circle-menu");
      const toggleButton = event.target.closest(".c-circle-menu__toggle");
      if (menu && toggleButton) {
        toggleButton.classList.toggle("is-active");
        menu.classList.toggle("is-active"); // Toggle the menu visibility
      }
    }
  };

  return null;
};

export { SeoDymanicContent };
